module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-tisch-05.3fdd5c64.jpeg";